import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder, RequiredValidator } from '@angular/forms';
import CONSTANTS from '../../../core/constants';
import { StandardListService } from '../../../core/services/standard-list.service';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxHotjarService } from 'ngx-hotjar';
import { environment } from '../../../../environments/environment';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-schooling-modal',
  templateUrl: './schooling-modal.component.html',
  styleUrls: ['./schooling-modal.component.scss']
})

export class SchoolingModalComponent implements OnInit {
  @Input() modalTitle;
  @Input() schoolingLevels;

  @Input() type;
  @Input() item;

  @Input() matchmakingObj;
  @Input() update;

  @Input() colors;

  currentSchoolingLevel;
  schoolingCourses;
  courseLevel;
  institutionLevel;
  STATES = CONSTANTS.STATES;
  SCHOOLING_LEVELS = CONSTANTS.SCHOOLING_LEVELS_MATCHMAKING;

  auxResults: any = {};
  courses: Array<any>;
  filteredCourses;
  coursesArea: any;
  coursesSubArea: any;

  modalForm: FormGroup;
  hasMatchMakingRoute: boolean;
  readyToUpdate: boolean = true;
  filtered: boolean;
  filter: boolean;

  constructor(
    private activeModal: NgbActiveModal,
    private standardListService: StandardListService,
    protected route: Router,
    protected $hotjar: NgxHotjarService,
    public router: Router,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
  ) { }

  ngOnInit() {
    this.$hotjar.virtualPageView(`${environment.web_link}${this.router.url}`);
    if (!this.schoolingLevels) {
      this.setSchoolingLevels();
    }

    if (!this.update) {
      this.readyToUpdate = false
    }

    this.modalForm = this.formBuilder.group({
      level: new FormControl('', [Validators.required]),
      levelType: new FormControl(''),
      standardSchoolCourse: new FormControl(''),
      standardSchoolCourseArea: new FormControl(''),
      courseSubArea: new FormControl(''),
      standardInstitution: new FormControl(''),
      state: new FormControl(''),
      ead: new FormControl(false),
      presencial: new FormControl(false),
      canBeEad: new FormControl(null),
      period: new FormGroup({
        morning: new FormControl(false),
        afternoon: new FormControl(false),
        night: new FormControl(false)
      }),
      finished: new FormGroup({
        since: new FormControl(''),
        until: new FormControl(''),
      }),
      typeCourse: this.formBuilder.array([]),
      selectAll: new FormControl(false)
    });

    this.hasMatchMakingRoute = this.route.url.includes('create');

    this.fillForm();
  }

  fillForm() {
    if (this.update) {
      this.auxResults = this.auxResults || {};
      this.modalForm.patchValue(this.item);
      this.modalForm.get('standardSchoolCourse').patchValue(this.item.standardSchoolCourse && this.item.standardSchoolCourse.name ? this.item.standardSchoolCourse.name : undefined);
      this.auxResults['standardSchoolCourse'] = this.item.standardSchoolCourse && this.item.standardSchoolCourse.standardListId ? this.item.standardSchoolCourse.standardListId : undefined;
      this.auxResults['standardInstitution'] = this.item.standardInstitution && this.item.standardInstitution.standardListId ? this.item.standardInstitution.standardListId : undefined;

      if (this.item && Array.isArray(this.item.typeCourse)) {
        const hasDistance = this.item.typeCourse.indexOf('distanceEducation') !== -1;
        const hasCommon = this.item.typeCourse.indexOf('common') !== -1;

        this.modalForm.get('ead').patchValue(hasDistance);
        this.modalForm.get('presencial').patchValue(hasCommon);

        // synchronize FormArray typeCourse correctly
        const typeCourseArray = this.modalForm.get('typeCourse') as FormArray;
        if (typeCourseArray) {
          while (typeCourseArray.length > 0) {
            typeCourseArray.removeAt(0);
          }
        }
        if (this.item.typeCourse && this.item.typeCourse.length) {
          for (let i = 0; i < this.item.typeCourse.length; i++) {
            typeCourseArray.push(new FormControl(this.item.typeCourse[i]));
          }
        }
      }

      this.selectOnChange(this.modalForm.get('level').value);
    }
  }

  enableSubareaAndCourse(): boolean {
    return !this.modalForm.get('standardSchoolCourseArea').value;
  }

  messageIfTheAreaHasNotFilled(): void {
    if (this.enableSubareaAndCourse()) {
      this.toastrService.clear();
      this.toastrService.info('Para habilitar este campo, preencha a área do curso.', 'Campo desabilitado!')
    }
  }

  setSchoolingLevels() {
    this.schoolingLevels = this.SCHOOLING_LEVELS.map(level => ({ type: level.value }));
  }

  closeModal() {
    this.activeModal.close();
  }

  onSelectAllChange(event: any) {
    if (event.checked) {
      this.modalForm.get('level').setValue(null);
      this.modalForm.get('levelType').setValue(null);
      this.modalForm.get('standardSchoolCourseArea').setValue(null);
      this.modalForm.get('standardSchoolCourse').setValue(null);
      this.modalForm.get('courseSubArea').setValue(null);
      this.modalForm.get('standardInstitution').setValue(null);
      this.modalForm.get('state').setValue(null);
      this.modalForm.get('ead').setValue(false);
      this.modalForm.get('presencial').setValue(false);
      this.modalForm.get('canBeEad').setValue(null);
      this.modalForm.get('typeCourse').patchValue([]);
      this.currentSchoolingLevel = null;
    }
  }

  selectOnChange(target, clean?) {
    if (clean) {
      this.modalForm.get("finished.since").patchValue(null);
      this.modalForm.get("finished.until").patchValue(null);
      this.modalForm.get("standardSchoolCourseArea").patchValue(null);
      this.modalForm.get("standardSchoolCourse").patchValue(null);
      this.modalForm.get("courseSubArea").patchValue(null);
      this.modalForm.get("levelType").patchValue(null);
      this.modalForm.get("standardInstitution").patchValue(null);
      this.modalForm.get("state").patchValue(null);
      this.modalForm.get("ead").patchValue(false);
      this.modalForm.get("presencial").patchValue(false);
      this.modalForm.get("canBeEad").patchValue(null);
      this.modalForm.get("typeCourse").patchValue([]);
      this.auxResults = {};
    }

    let selectedItem;

    if (target && target.source) {
      selectedItem = target.source.selected.id;
    } else {
      selectedItem = target;
    }

    this.currentSchoolingLevel = selectedItem;

    this.setSearchListsLevels();
    this.setCoursesType();
  }

  setCoursesType(): void {
    this.schoolingCourses = this.schoolingLevels.filter(level => this.currentSchoolingLevel === level.type);
  }

  setSearchListsLevels() {
    const apiTypes = {
      sup: ['higher_education_course', 'higher_education_institution'], // sup = superior
      tec: ['technical_education_course', 'technical_education_institution'] // tec = tecnico
    };

    this.courseLevel = undefined
    this.institutionLevel = undefined

    const [supLevel, tecLevel] = Object.keys(apiTypes);
    if (this.currentSchoolingLevel && this.currentSchoolingLevel.indexOf(supLevel) >= 0) {
      this.courseLevel = apiTypes[supLevel][0];
      this.institutionLevel = apiTypes[supLevel][1];
    }

    if (this.currentSchoolingLevel && this.currentSchoolingLevel.indexOf(tecLevel) >= 0) {
      this.courseLevel = apiTypes[tecLevel][0];
      this.institutionLevel = apiTypes[tecLevel][1];
    }

    if (this.courseLevel) {
      this.standardListService.getList({ type: this.courseLevel })
        .pipe(take(1))
        .subscribe(courses => {
          this.courses = courses;
          this.filteringCourses('area');
        });
    }
  }

  setAreas() {
    this.coursesArea = this.courses
      .filter(element => element.schoolCourse && element.schoolCourse.area && element.schoolCourse.validated)
      .map(element => element.schoolCourse.area);

    this.coursesArea = this.coursesArea.filter((este, i) => this.coursesArea.indexOf(este) === i && este != null);

    this.coursesSubArea = this.courses
      .filter(element => element.schoolCourse && element.schoolCourse.area && element.schoolCourse.subArea)
      .map(element => this.modalForm.get('standardSchoolCourseArea').value == element.schoolCourse.area ? element.schoolCourse.subArea : null);

    this.coursesSubArea = this.coursesSubArea.filter((este, i) => this.coursesSubArea.indexOf(este) === i && este != null);
  }

  filteringCourses(type) {
    const control = type === 'area' ? 'standardSchoolCourseArea' : 'courseSubArea';

    if (!this.readyToUpdate) {
      if (type == 'area') {
        this.modalForm.get('courseSubArea').patchValue(null);
        this.modalForm.get('standardSchoolCourse').patchValue(null);
      } else {
        this.modalForm.get('standardSchoolCourse').patchValue(null);
      }
    }

    this.readyToUpdate = false;
    const value = this.modalForm.get(control).value;
    this.setAreas();
    this.filteredCourses = this.courses.filter(course => course.schoolCourse && course.schoolCourse[type] && course.schoolCourse[type] === value);
  }

  addNewSchoolingLevel() {
    if (this.modalForm.get('selectAll').value) {
      const allSchoolingLevels = this.SCHOOLING_LEVELS.map(level => {
        const schoolingData = _.cloneDeep(this.modalForm.value);
        delete schoolingData.ead;
        delete schoolingData.presencial;
        schoolingData.typeCourse = [];
        schoolingData.canBeEad = null;
        schoolingData.level = level.value;
        schoolingData.name = level.name;
        schoolingData.levelType = null;
        schoolingData.standardSchoolCourse = null;
        schoolingData.standardSchoolCourseArea = null;
        schoolingData.courseSubArea = null;
        schoolingData.standardInstitution = null;
        schoolingData.state = null;
        schoolingData.ead = false;
        schoolingData.presencial = false;
        schoolingData.canBeEad = null;
        schoolingData.period = { morning: false, afternoon: false, night: false };
        schoolingData.finished = { since: null, until: null };

        return {
          level: level.value,
          type: this.type,
          item: schoolingData
        };
      });

      this.activeModal.close({
        value: allSchoolingLevels.map(level => level.level),
        schooling: allSchoolingLevels
      });
      return;
    } else {
      for (let x in this.courses) {
        this.filter = this.courses[x].schoolCourse.name === this.modalForm.get('standardSchoolCourse').value;
        if (this.filter) {
          this.filtered = true;
        }
      }

      if (this.modalForm.valid) {
        if (this.update) {
          let result: any = {};
          const schooling = _.cloneDeep(this.modalForm.value);

          if (schooling.level && (schooling.level.includes('sup') || schooling.level.includes('tec-med')) && schooling.standardSchoolCourse) {
            if (this.filtered || this.auxResults['standardSchoolCourse']) {
              schooling.standardSchoolCourse = {
                name: schooling.standardSchoolCourse,
                standardListId: this.auxResults['standardSchoolCourse'],
              };
            } else {
              this.toastrService.clear();
              this.toastrService.warning('Selecione algum curso da lista.', 'Atenção!');
              return;
            }
          }

          if (schooling.level && (schooling.level.includes('sup') || schooling.level.includes('tec-med')) && schooling.standardInstitution) {
            if (this.auxResults['standardInstitution']) {
              schooling.standardInstitution = {
                name: schooling.standardInstitution,
                standardListId: this.auxResults['standardInstitution'],
              };
            }
          }

          schooling.typeCourse = schooling.typeCourse || [];
          if (schooling.ead) {
            schooling.typeCourse.push('distanceEducation');
            delete schooling.ead;
          }

          if (schooling.presencial) {
            schooling.typeCourse.push('common');
            delete schooling.presencial;
          }

          const levelMasked = result.level;
          result = {
            ...result,
            ...{
              level: this.currentSchoolingLevel,
              type: this.type,
              item: result
            }
          };

          this.activeModal.close({
            value: [levelMasked],
            schooling: schooling
          });
          return;
        }

        let result: any = {};
        const schooling = _.cloneDeep(this.modalForm.value);

        if (schooling.level && (schooling.level.includes('sup') || schooling.level.includes('tec-med')) && schooling.standardSchoolCourse) {
          if (this.filtered) {
            schooling.standardSchoolCourse = {
              name: schooling.standardSchoolCourse,
              standardListId: this.auxResults['standardSchoolCourse'],
            };
          } else {
            this.toastrService.clear();
            this.toastrService.warning('Selecione algum curso da lista.', 'Atenção!');
            return;
          }
        }

        if (schooling.level && (schooling.level.includes('sup') || schooling.level.includes('tec-med')) && schooling.standardInstitution) {
          if (this.auxResults['standardInstitution']) {
            schooling.standardInstitution = {
              name: schooling.standardInstitution,
              standardListId: this.auxResults['standardInstitution'],
            };
          }
        }

        schooling.typeCourse = schooling.typeCourse || [];
        if (schooling.ead) {
          schooling.typeCourse.push('distanceEducation');
          delete schooling.ead;
        }

        if (schooling.presencial) {
          schooling.typeCourse.push('common');
          delete schooling.presencial;
        }

        result = { ...schooling };
        const levelMasked = result.level;

        result = {
          ...result,
          ...{
            level: this.currentSchoolingLevel,
            type: this.type,
            item: result
          }
        };

        this.activeModal.close({
          value: [levelMasked],
          schooling: result
        });
      } else {
        this.toastrService.clear();
        this.toastrService.warning('Preencha todos os campos obrigatórios.', 'Atenção!');
      }
    }
  }

  showInvalid(fieldPath: string) {
    const control = this.modalForm.get(fieldPath);
    return !control.valid && control.touched;
  }

  getListItem(event) {
    const { item, type } = event;
    this.auxResults = this.auxResults || {};

    this.auxResults[type] = item._id;
    let subArea = item.schoolCourse && item.schoolCourse.subArea ? item.schoolCourse.subArea : undefined;
    this.modalForm.get('courseSubArea').setValue(subArea);
  }

  getInstitutionListItem(event) {
    const { item, type } = event;

    this.auxResults = this.auxResults || {};

    this.auxResults[type] = item._id;
  }

  setCheckValue(presencial, ead) {
    if (!presencial.checked && !ead.checked) {
      this.modalForm.get('canBeEad').patchValue(null);
    } else if (presencial.checked && !ead.checked) {
      this.modalForm.get('canBeEad').patchValue(false);
    } else {
      this.modalForm.get('canBeEad').patchValue(true);
    }
  }

  addItem(item) {
    const attribute = this.modalForm.get('typeCourse') as FormArray;
    if (!attribute) { return; }
    const index = attribute.controls.findIndex(ctrl => String(ctrl.value) === String(item));
    if (index === -1) {
      attribute.push(new FormControl(item));
    } else {
      attribute.removeAt(index);
    }
    attribute.markAsTouched();
    attribute.updateValueAndValidity();
  }

  onTypeCourseCheckboxChange(type: string, checked: boolean) {
    const control = this.modalForm.get('typeCourse') as FormArray;
    if (!control) { return; }
    if (checked) {
      const exists = control.controls.some(c => String(c.value) === String(type));
      if (!exists) {
        control.push(new FormControl(type));
      }
    } else {
      const idx = control.controls.findIndex(c => String(c.value) === String(type));
      if (idx > -1) {
        control.removeAt(idx);
      }
    }
    control.markAsTouched();
    control.updateValueAndValidity();
  }
}